import store from '@/store';
import { checkinApi } from '@/services/api/httpClient';
import { parseToArray } from '@/utils/config/utils';
export const validateRulesForRedirectToMF = async (route) => {
  let redirectToMF = false;
  const isT2PrivateFlowAllowed = store.getters['global/isT2FlowAllowed'];
  const isT2HealthInsuranceFlowAllowed = store.getters['global/isT2HealthInsuranceFlowAllowed'];
  const routesRedirectToMF = parseToArray(process.env.CHECKIN_AS_IS_ROUTE_REDIRECT_TO_MF);
  const isRouteRedirectToMF = routesRedirectToMF.includes(route);
  const scheduledAdmission = store.state.currentAdmission.data?.source?.origin !== 'AUT';

  if (
    isRouteRedirectToMF &&
    !isT2PrivateFlowAllowed &&
    !isT2HealthInsuranceFlowAllowed &&
    scheduledAdmission
  ) {
    const isBrandOrUnitIdRedirectToMF = await getConfigRedirect();
    if (isBrandOrUnitIdRedirectToMF) redirectToMF = true;
  }

  return redirectToMF;
};

const getConfigRedirect = async () => {
  const brandId = store.getters.getBrandUnitIdVariables.brandId;
  const unitId = store.getters.getBrandUnitIdVariables.unitId;
  let isBrandOrUnitIdRedirectToMF = false;
  try {
    const response = await checkinApi().get(
      `unit/redirect-nav?brandId=${brandId}&unitId=${unitId}`,
    );

    isBrandOrUnitIdRedirectToMF = response.data;
  } catch (error) {
    console.error('Error fetching redirect config:', error);
  }
  return isBrandOrUnitIdRedirectToMF;
};
